/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';

export const MASK_SHAPES = [
    { label: __('None', 'progressmatify-blocks'), value: 'none' },
    { label: __('Blob', 'progressmatify-blocks'), value: 'blob' },
    { label: __('Circle', 'progressmatify-blocks'), value: 'circle' },
    { label: __('Hexagon', 'progressmatify-blocks'), value: 'hexagon' },
    { label: __('Sketch', 'progressmatify-blocks'), value: 'sketch' },
    { label: __('Triangle', 'progressmatify-blocks'), value: 'triangle' }
];

export const MASK_SIZES = [
    { label: __('auto', 'progressmatify-blocks'), value: 'auto' },
    { label: __('cover', 'progressmatify-blocks'), value: 'cover' },
    { label: __('contain', 'progressmatify-blocks'), value: 'contain' }
];

export const MASK_POSITIONS = [
    { label: __('Left Top', 'progressmatify-blocks'), value: 'left top' },
    { label: __('Left Center', 'progressmatify-blocks'), value: 'left center' },
    { label: __('Left Bottom', 'progressmatify-blocks'), value: 'left bottom' },
    { label: __('Right Top', 'progressmatify-blocks'), value: 'right top' },
    { label: __('Right Center', 'progressmatify-blocks'), value: 'right center' },
    { label: __('Right Bottom', 'progressmatify-blocks'), value: 'right bottom' },
    { label: __('Center Top', 'progressmatify-blocks'), value: 'center top' },
    { label: __('Center Center', 'progressmatify-blocks'), value: 'center center' },
    { label: __('Center Bottom', 'progressmatify-blocks'), value: 'center bottom' }
];

export const MASK_REPEATS = [
    { label: __('no-repeat', 'progressmatify-blocks'), value: 'no-repeat' },
    { label: __('repeat', 'progressmatify-blocks'), value: 'repeat' },
    { label: __('repeat-x', 'progressmatify-blocks'), value: 'repeat-x' },
    { label: __('repeat-y', 'progressmatify-blocks'), value: 'repeat-y' }
];
